import { ReactNode } from 'react'
import { twMerge } from 'tailwind-merge'

interface EmptyDataMessageProps {
  className?: string
  imageHeight?: number
  message?: string | ReactNode
  dataTestId?: string
}

export const EmptyDataMessage = ({ className, imageHeight, message, dataTestId }: EmptyDataMessageProps) => {
  return (
    <div className={twMerge('flex w-full flex-col items-center gap-3 h-screen overflow-auto', className)}>
      <div className="mt-auto">
        <img src="/search.gif" className={twMerge('shrink-0', imageHeight ? `h-[${imageHeight}px]` : 'w-[305px]')} />
      </div>
      <div className="-mt-16 mb-auto p-8">
        <p data-testid={dataTestId || "empty_message_preview"} className="text-sm font-bold text-center mt-2">{message || 'Parece que ainda não há registros aqui.'}</p>
      </div>
    </div>
  )
}
